export const GET_PREDICTIONS_START = "@@PREDICTIONS/GET_PREDICTIONS_START";
export const GET_PREDICTIONS_SUCCESS = "@@PREDICTIONS/GET_PREDICTIONS_SUCCESS";
export const GET_PREDICTIONS_FAILED = "@@PREDICTIONS/GET_PREDICTIONS_FAILED";
export const SET_EDITOR_DIRTY = "@@PREDICTIONS/SET_EDITOR_DIRTY";
export const RESET_EDITOR_DIRTY = "@@PREDICTIONS/RESET_EDITOR_DIRTY";
